import CryptoJS from "crypto-js";

const SECRET_KEY = "Pazzw@rD1$$%=";

export const encryptData = (data) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
};

export const decryptData = (ciphertext) => {
  const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY);
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
};

// Retrieve encrypted sessionData from localStorage and decrypt it
export const getSessionData = () => {
  const encryptedData = localStorage.getItem("sessionData");
  if (!encryptedData) return null;
  try {
    return decryptData(encryptedData);
  } catch (error) {
    console.error("Error decrypting session data:", error);
    return null;
  }
};

// Set sessionData to localStorage after encrypting it
export const setSessionData = (newSessionData) => {
  const encryptedData = encryptData(newSessionData);
  localStorage.setItem("sessionData", encryptedData);
};

// Clear sessionData from localStorage
export const clearSessionData = () => {
  localStorage.removeItem("sessionData");
};

export const getUserId = () => {
  const sessionData = getSessionData();
  return sessionData?.emailAddress || null;
};

// Get accessToken
export const getAccessToken = () => {
  const sessionData = getSessionData();
  return sessionData?.accessToken || null;
};

// Set accessToken
export const setAccessToken = (accessToken) => {
  const sessionData = getSessionData();
  const newSessionData = {
    ...sessionData,
    accessToken,
  };
  setSessionData(newSessionData);
};

// Get refreshToken
export const getRefreshToken = () => {
  const sessionData = getSessionData();
  return sessionData?.refreshToken || null;
};

// Set refreshToken
export const setRefreshToken = (refreshToken) => {
  const sessionData = getSessionData();
  const newSessionData = {
    ...sessionData,
    refreshToken,
  };
  setSessionData(newSessionData);
};

// Generic recent items management
const getRecentItemsKey = (type) => `recent_${type}_${getUserId()}`;

// Generic function to save recent items
export const saveToRecentItems = (type, item, setRecentItems, maxItems = 10) => {
  try {
    const key = getRecentItemsKey(type);
    let recent = [];

    // Try to decrypt existing data
    const existingData = localStorage.getItem(key);
    if (existingData) {
      try {
        recent = decryptData(existingData);
      } catch (error) {
        console.warn(`Could not decrypt existing recent ${type}, starting fresh`);
        recent = [];
      }
    }

    // Remove if already exists
    recent = recent.filter(existingItem => existingItem.id !== item.id);

    // Add to beginning with timestamp
    recent.unshift({
      ...item,
      timestamp: Date.now()
    });

    // Keep only the specified max items
    recent = recent.slice(0, maxItems);

    // Encrypt and save
    const encryptedData = encryptData(recent);
    localStorage.setItem(key, encryptedData);
    setRecentItems(recent);
  } catch (error) {
    console.error(`Error saving recent ${type}:`, error);
  }
};

// Generic function to load recent items
export const loadRecentItems = (type, setRecentItems) => {
  try {
    const key = getRecentItemsKey(type);
    const encryptedData = localStorage.getItem(key);
    if (encryptedData) {
      const recent = decryptData(encryptedData);
      setRecentItems(recent);
    } else {
      setRecentItems([]);
    }
  } catch (error) {
    console.error(`Error loading recent ${type}:`, error);
    setRecentItems([]);
  }
};

// Convenience functions for specific types (backward compatibility)
export const saveToRecentConfigs = (config, setRecentConfigs) => {
  saveToRecentItems('configs', config, setRecentConfigs);
};

export const loadRecentConfigs = (setRecentConfigs) => {
  loadRecentItems('configs', setRecentConfigs);
};

export const saveToRecentChains = (chain, setRecentChains) => {
  saveToRecentItems('command_chains', chain, setRecentChains);
};

export const loadRecentChains = (setRecentChains) => {
  loadRecentItems('command_chains', setRecentChains);
};

export const saveToRecentPlatforms = (platform, setRecentPlatforms) => {
  saveToRecentItems('platforms', platform, setRecentPlatforms);
};

export const loadRecentPlatforms = (setRecentPlatforms) => {
  loadRecentItems('platforms', setRecentPlatforms);
};

export const getRecentConfigsKey = () => getRecentItemsKey('configs');
export const getRecentChainsKey = () => getRecentItemsKey('command_chains');
export const getRecentPlatformsKey = () => getRecentItemsKey('platforms');